export const EMPTY_DATA_SET_SCHEMA = {
  $schema: 'http://json-schema.org/draft-04/schema#',
  '$schema-id': 123456789,
  type: 'object',
  properties: {},
};

export const MOCK_SYSLOG_DETECTED_SCHEMA = {
  $schema: 'http://json-schema.org/draft-04/schema#',
  '$schema-id': 123456789,
  type: 'object',
  properties: {
    dataset_id: {
      type: 'number',
    },
    source_id: {
      type: 'number',
    },
  },
};
